// Cookies type
const cookiesServidor        = 'localhost';
// const cookiesServidor         = 'chroma-dash-internacional.chroma-garden.com/';
export const cookiesRegister  = cookiesServidor;

// Cookies name
export const typeCookie       = 'chroma_internacional_dash';
export const typeCookiePassw  = 'chroma_internacional_passw';
export const typeCookieEmail  = 'chroma_internacional_email';
export const typeCookiePage   = 'chroma_internacional_page';
export const typeCookiePageId = 'chroma_internacional_page_id';
export const typeCookieNewId  = 'chroma_internacional_new_id';

// opt box editor
export const config = {
    zIndex: 0,
    readonly: false,
    width: 'auto',
    height: 'auto',
    minHeight: 100,
    direction: '',
    language: 'auto',
    tabIndex: -1,
    buttons: ['bold', 'italic', 'underline', 'image', 'link', 'align', 'paragraph', 'ul', 'ol', 'source'],
    link: {
        modeClassName: false,
        noFollowCheckbox: false,
        openInNewTabCheckbox: false,
        processPastedLink: false,
        processVideoLink: false,
        selectMultipleClassName: false,
        selectOptionsClassName: false,
    },
    imageDefaultWidth: 24,
    image: {
        dialogWidth: true,
        editAlign: false,
        editAlt: false,
        editBorderRadius: true,
        editClass: false,
        editId: false,
        editLink: true,
        editMargins: false,
        editSize: true,
        editSrc: true,
        editStyle: false,
        editTitle: false,
        openOnDblClick: true,
        selectImageAfterClose: true,
        showPreview: true,
        useImageEditor: true,
    },
    placeholder: "Digite o texto aqui...",
    toolbarAdaptive: false
}